var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.413 13.6628L18.163 24.9128C17.9867 25.0863 17.749 25.1831 17.5017 25.1821C17.2544 25.1811 17.0175 25.0824 16.8426 24.9076C16.6677 24.7327 16.5689 24.4958 16.5679 24.2485C16.5669 24.0012 16.6636 23.7635 16.837 23.5872L26.4867 13.9375H1.25C1.00136 13.9375 0.762903 13.8387 0.587087 13.6629C0.411272 13.4871 0.3125 13.2486 0.3125 13C0.3125 12.7513 0.411272 12.5129 0.587087 12.3371C0.762903 12.1612 1.00136 12.0625 1.25 12.0625H26.4867L16.837 2.41279C16.6636 2.23647 16.5669 1.99876 16.5679 1.75144C16.5689 1.50413 16.6677 1.26724 16.8426 1.09238C17.0175 0.917521 17.2544 0.818856 17.5017 0.817878C17.749 0.816901 17.9867 0.913688 18.163 1.08716L29.413 12.3372C29.5 12.4242 29.5691 12.5275 29.6162 12.6413C29.6633 12.755 29.6875 12.8769 29.6875 13C29.6875 13.1231 29.6633 13.245 29.6162 13.3587C29.5691 13.4724 29.5 13.5757 29.413 13.6628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.562a31be.svg";
export { ForwardRef as ReactComponent };